<!--
  <form
    method="post"
    action="" enctype="multipart/form-data"
    :class="classObject"
    @dragenter="onDragEnter"
    @dragover="onDragEnter"
    @dragleave="onDragLeave"
    @dragend="onDragLeave"
  >
    <div class="box__input">
      <input class="box__file" type="file" name="files[]" :id="id" data-multiple-caption="{count} files selected" multiple />
      <label :for="id"><strong>ファイルを選択</strong>
        <span class="box__dragndrop"> or drag it here</span>.
      </label>
    </div>

    <div class="uploading">Uploading&hellip;</div>
    <div class="success">Done!</div>
    <div class="error">Error! <span></span>.</div>
  </form>
-->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
// @import '~@/assets/theme.scss';

input {
  display:none;
}
label {
  position: relative;
  display: inline-block;
  border-radius: 5px;
  cursor: pointer;
  width: 150px; // default size
  height: 150px; // default size
  text-align: center;
  transition: all 0.2s;
}
// label:hover {
//   background: #B07DCE;
// }
.light {
  color: #A6A6A6;
}
.dragover {
  opacity: 0.6;
  background-color: red;
}
.label-inner {
  $mg: 10px;
  $fs: 1.0rem;

  position: absolute;
  top: $mg;
  right: $mg;
  bottom: $mg;
  left: $mg;
  font-size: $fs;
  .icon-area {
    text-align: center;
    padding: .8rem;
  }
  // .icon {
    // vertical-align: -15%;
    // font-size: $fs;
  // }
  .material-icons.md-48 { font-size: 48px; }
}
</style>

<template>
  <div>
    <label
      :for="id"
      :style="styleObject"
      :class="classObject"
      @dragenter="onDragEnter"
      @dragover="onDragOver"
      @dragleave="onDragLeave"
      @drop="onDrop"
    >
      <section class="label-inner">
        <div class="icon-area">
          <i class="material-icons md-48">folder_open</i>
        </div>
        <p>pxbpファイルと音源ファイルの<br>選択・ロード</p>
        <div v-if="isCovered">
          ドロップ！
        </div>
      </section>

    </label>
    <input type="file"
      :id="id"
      @change="onInputChange"
    >
  </div>
</template>

<script>

// 子要素にdragenterしてチカチカさせない
// ref: https://qiita.com/sounisi5011/items/dc4878d3e8b38101cf0b
let innerFlag = false;

export default {
  name: 'inputFileField',
  props: {
    width: Number,
    height: Number,
  },

  data() {
    return {
      id: null,
      isCovered: false,
    }
  },

  computed: {
    styleObject() {
      return {
        margin: '10px',
        width: this.width + 'px',
        height: this.height + 'px',
      }
    },
    classObject() {
      return {
        // "t-gray-b": true,
        "t-pastelgreen-b": true,
        dragover: this.isCovered,
      }
    }
  },

  mounted() {
    // label forのため、ユニークIDを指定
    this.id = this._uid
  },

  methods: {
    onInputChange(evt) {
      // console.log('chg evt', evt)
      this.$emit('change', evt);
    },
    onDrop(evt) {
      this.isCovered = false;
      // evt.preventDefault();
      // evt.stopPropagation();
      this.$emit('drop', evt);
    },
    onDragEnter(evt) {
      // console.log('enter')
      innerFlag = true;
    },
    onDragOver(evt) {
      innerFlag = false;
      this.isCovered = true;
    },
    onDragLeave(evt) {
      // console.log('exit')
      if (innerFlag) {
        //フラグがセットされている場合、フラグを戻す
        innerFlag = false;
      } else {
        //フラグがセットされていない場合、クラスを削除
        this.isCovered = false;
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/sub/InputFileField.vue